import { createPinia } from 'pinia';
import { createApp } from 'vue';
import router from './router';
import App from './App.vue';

import '@/assets/scss/index.scss';

// Theme 패키지 import (CSS 변수 포함)
import '@template/theme';

// UI 패키지 import (스타일 포함)
import '@template/ui/ui.css';
import '@template/ui';

// 전역 스타일
import './style.css';

// TradingView 차트 선언은 @template/chart 패키지에서 관리

import { setAccountStoreServices, useAccountStore } from '@template/stores';
import { LocalStorageService, LocalStorageKey } from '@template/utils';
import { getWebSocketService } from './services/websocket';
import websocketPlugin from './plugins/websocket';
import { isMobile, isIOS } from '@template/utils';
import { initializeManagers } from './managers';
import { authService } from './services/api';
import { useTheme } from '@template/theme';

const app = createApp(App);

app.use(createPinia());

// AccountStore 서비스 설정 (websocketPlugin 등록 전에 먼저 초기화)
// accountStore는 로그인, 계좌 유무 등을 판단하는 스토어로서 항상 먼저 초기화되어야 함
setAccountStoreServices({
  getLocalStorageItem: (key: string) => LocalStorageService.getItem(key),
  setLocalStorageItem: (key: string, value: any) => LocalStorageService.setItem(key, value),
  removeLocalStorageItem: (key: string) => LocalStorageService.removeItem(key),
  getWebSocketService: () => getWebSocketService(),
  authService: authService,
  LocalStorageKey: LocalStorageKey,
});

app.use(router);
app.use(websocketPlugin);

// 앱 마운트 전에 테마 초기화
const theme = useTheme();
theme.updateHtmlClass();

async function initializeApp() {
  const isProduction = import.meta.env.MODE === 'production';

  if (isMobile && isProduction) {
    const mobileUrl = isIOS
      ? import.meta.env.VITE_MODA_APP_STORE_URL
      : import.meta.env.VITE_MODA_PLAY_STORE_URL;
    return window.location.replace(mobileUrl);
  }

  try {
    // 1. AccountStore 초기화 (가장 먼저 실행되어야 함)
    // 다른 스토어들이 accountStore에 의존하므로 초기화 순서를 보장
    const accountStore = useAccountStore();

    const isAccountAuthorized = LocalStorageService.getItem(LocalStorageKey.ACCOUNT_TOKEN) !== null;
    await accountStore.initialize(isAccountAuthorized);

    // 2. Manager들 초기화
    await initializeManagers();
  } catch (error) {
    console.error('[Main] 초기화 실패:', error);
  }

  app.mount('#app');
}

initializeApp();
